import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
//services

import { CountsDashboardComponent } from './counts-dashboard.component';
import { AppCodeGroup, ControlsParams } from '../../shared';
import { SharedModule } from '../ngPrime/common/shared';
import { BlocksModule } from '../blocks.module';
import { TranslateModule } from '@ngx-translate/core';
import { FastSearchModule } from '../ui-component/fast-search/fast-search.module';
import { NgbDatepickerModule } from '../../ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';


@NgModule({
  declarations: [
    CountsDashboardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BlocksModule,
    // NgXDonutChartModule,
    TranslateModule,
    FastSearchModule,
    NgbDatepickerModule,
    NgxChartsModule,
    FormsModule
  ],
  exports: [
    RouterModule,
    CountsDashboardComponent
  ],
  providers: [
  ]
})
export class CountsDashBoardModule {
}
